<template>
  <div>
    <p>Monitor your logical endpoints to understand how each service in your system is performing:</p>
    <ul>
      <li><strong>Endpoint details</strong> - See your logical endpoint at a glance</li>
      <li><strong>Aggregated metrics</strong> - View combined metrics across all instances of an endpoint</li>
      <li><strong>Throughput trends</strong> - Track message processing rates over time</li>
      <li><strong>Health indicators</strong> - Quickly identify endpoints that need attention</li>
    </ul>
  </div>
</template>
